import { Box, Image, Link, Text, VStack } from '@chakra-ui/react';
import { useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface PaymentProofPdfPreviewProps {
  index: number;
  url: string;
}

interface PaymentProofPdfPageProps {
  pageNumber: number;
}

function PaymentProofPdfPage({ pageNumber }: PaymentProofPdfPageProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [printImageUrl, setPrintImageUrl] = useState('');

  const handleRenderSuccess = () => {
    try {
      setPrintImageUrl(canvasRef.current?.toDataURL('image/png') ?? '');
    } catch {
      setPrintImageUrl('');
    }
  };

  return (
    <Box
      data-testid="payment-proof-pdf-page"
      border="1px solid"
      borderColor="#EDF2F7"
      overflow="hidden"
      bg="#F7FAFC"
      sx={{
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
        '.payment-proof-pdf-print-image': {
          display: 'none',
        },
        '@media print': {
          '.react-pdf__Page': {
            display: 'none',
          },
          '.payment-proof-pdf-print-image': {
            display: 'block',
          },
        },
      }}
    >
      <Page
        pageNumber={pageNumber}
        width={360}
        renderAnnotationLayer={false}
        renderTextLayer={false}
        canvasBackground="#FFFFFF"
        canvasRef={canvasRef}
        onRenderSuccess={handleRenderSuccess}
      />
      {printImageUrl ? (
        <Image
          className="payment-proof-pdf-print-image"
          src={printImageUrl}
          alt={`PDF Bukti Transfer ${pageNumber}`}
          width="100%"
        />
      ) : null}
    </Box>
  );
}

export function PaymentProofPdfPreview({
  index,
  url,
}: PaymentProofPdfPreviewProps) {
  const [numPages, setNumPages] = useState(0);

  return (
    <Box
      data-testid="payment-proof-pdf-preview"
      border="1px solid"
      borderColor="#E2E8F0"
      borderRadius="8px"
      bg="white"
      p={3}
      sx={{
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
        '.react-pdf__Page': {
          display: 'flex',
          justifyContent: 'center',
        },
        '.react-pdf__Page__canvas': {
          width: '100% !important',
          height: 'auto !important',
        },
      }}
    >
      <VStack align="stretch" spacing={3}>
        <Box>
          <Text fontSize="14px" fontWeight="bold" color="#333333">
            PDF Bukti Transfer {index + 1}
          </Text>
          <Link
            href={url}
            isExternal
            rel="noopener noreferrer"
            color="blue"
            fontSize="13px"
            fontWeight="bold"
          >
            Open PDF
          </Link>
        </Box>
        <Document
          file={url}
          loading={
            <Text color="#777777" fontSize="13px">
              Memuat PDF...
            </Text>
          }
          error={
            <Text color="red.500" fontSize="13px">
              Gagal memuat PDF
            </Text>
          }
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        >
          <VStack align="stretch" spacing={3}>
            {Array.from({ length: numPages }, (_, pageIndex) => (
              <PaymentProofPdfPage
                key={`${url}-${pageIndex + 1}`}
                pageNumber={pageIndex + 1}
              />
            ))}
          </VStack>
        </Document>
      </VStack>
    </Box>
  );
}
